import PropTypes from 'prop-types';
import { HiNoSymbol } from 'react-icons/hi2';

import { useCustomColumns } from '../../models/queries';

/**
 * Why a campaign recipient is blocked: on the blacklist, or missing custom-column values.
 */
const BlockReasonBadge = ({ reason, missingKeys = [] }) => {
	const { data: columns = [] } = useCustomColumns();
	const nameOf = (key) => columns.find((column) => column.key === key)?.name ?? key;
	const label = reason === 'missing_variable' ? `Wert fehlt: ${missingKeys.map(nameOf).join(', ')}` : 'Blacklist';

	return (
		<span className="inline-flex items-center gap-1 rounded-full border border-bgBase-500 bg-bgBase-300 px-2.5 py-0.5 text-xs font-semibold text-text">
			<HiNoSymbol className="h-3 w-3" />
			{label}
		</span>
	);
};

BlockReasonBadge.propTypes = {
	reason: PropTypes.oneOf(['blacklist', 'missing_variable']),
	missingKeys: PropTypes.arrayOf(PropTypes.string),
};

export default BlockReasonBadge;
